module.exports = __webpack_public_path__ + "static/img/冯红1.4a12be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/冯红1.png
// module id = lQ6A
// module chunks = 1